import { Box, Skeleton } from "@mui/material";

const SkeletonCard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
        minHeight: "240px",
        padding: "18px",
        border: "1px solid #E0E0E0",
        borderRadius: "16px",
        background: "#fff",
        boxShadow: "0 5px 10px rgba(33, 89, 255, 0.15)",
      }}
    >
      {/* Ícone */}
      <Skeleton
        variant="rectangular"
        sx={{ width: 34, height: 34, borderRadius: "10px" }}
      />

      {/* Conteúdo */}
      <Box sx={{ mt: 2 }}>
        <Skeleton variant="text" sx={{ fontSize: { xs: 16, sm: 18 }, mb: 1 }} />
        <Skeleton variant="text" sx={{ fontSize: 12, width: "80%", mb: 1 }} />
        <Skeleton variant="text" sx={{ fontSize: 10, width: "90%" }} />
      </Box>

      {/* Status */}
      <Skeleton
        variant="rectangular"
        sx={{
          width: 64,
          height: 18,
          borderRadius: "10px",
          mt: 2,
          alignSelf: "flex-end",
        }}
      />
    </Box>
  );
};

export default SkeletonCard;
